import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren, ViewRef } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { RESULTS_NOT_FOUND, PRODUCT_CONFIG } from 'src/app/_common/product-config';
import { StatusCode, RenewalStatus, RenewalStatusValue } from 'src/app/_common/_enum/module.enum';
import { SortableDirective, SortEvent } from 'src/app/_directives/sortable.directive';
import { HeaderData } from 'src/app/_models/header-data';
import { RenewalsService } from '../_services/renewals.service';
import { RenewalCriteria } from './_models/renewal-criteria';

@Component({
  selector: 'app-renewal-overview',
  templateUrl: './renewal-overview.component.html',
  styleUrls: ['./renewal-overview.component.scss']
})
export class RenewalOverviewComponent implements OnInit {

  private criteria: RenewalCriteria;
  private resultsNotFound = RESULTS_NOT_FOUND;
  private productConfig = PRODUCT_CONFIG;
  private RenewalStatusEnum = RenewalStatus;
  private RenewalStatusValueEnum = RenewalStatusValue;

  private allRenewals;
  private renewalSummary;
  private renewals;
  private filterObj: Object[];
  private selectedRenewalStatus;
  private renewalStatus = "";
  private renewalStatusFilter: Object = {};
  private filterAccountValue = "";
  
  //Create HeaderData object to show the Data on Blue Header.
  private headerData: HeaderData;  
  private _total$ = new BehaviorSubject<number>(0);
  
  private hasAccess: boolean = true;
  private loading: boolean = false;

  private renewalPeriodOpenGray = false;
  private renewalInProgressGray = false;
  private offlineProcessingGray = false;
  private referredToUWGray = false;
  private renewalBoundGray = false;
  private viewDestroyed = false;

  @ViewChild('renewalPeriodOpen', { static: false }) renewalPeriodOpen;
  @ViewChild('renewalInProgress', { static: false }) renewalInProgress;
  @ViewChild('offlineProcessing', { static: false }) offlineProcessing;
  @ViewChild('referredToUW', { static: false }) referredToUW;
  @ViewChild('renewalBound', { static: false }) renewalBound;
  @ViewChild('chart', { static: false }) chart;
  @ViewChild('filteraccount', { static: false }) filteraccount;
  
  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;
  constructor(private router: Router, private cdRef: ChangeDetectorRef,private renewalsService: RenewalsService) { }

  ngOnInit() {
    this.criteria = new RenewalCriteria();
    this.renewalsService.storeRenewalAccountData({});
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.fetchRenewals();
    
    this.filterObj = [
      /* {filterIndex: 0, displayName : 'Filter by Renewal Status', value: '', group: 'Renewal'}, */
      {filterIndex: 0, displayName : 'All', value: 'All', group: 'Renewal', inChart: false},
      {filterIndex: 1, displayName : 'Renewal Period Open', value: RenewalStatusValue.RENEWAL_PERIOD_OPEN, group: 'Renewal', inChart: true},
      {filterIndex: 2, displayName : 'Renewal In Progress', value: RenewalStatusValue.RENEWAL_IN_PROGRESS, group: 'Renewal', inChart: true},
      {filterIndex: 3, displayName : 'Offline Processing', value: RenewalStatusValue.OFFLINE_PROCESSING, group: 'Renewal', inChart: true},
      {filterIndex: 4, displayName : 'Renewal Bound', value: RenewalStatusValue.RENEWAL_BOUND, group: 'Renewal', inChart: true},
      {filterIndex: 5, displayName : 'Renewal Issued', value: RenewalStatusValue.RENEWAL_ISSUED, group: 'Renewal', inChart: false},
      {filterIndex: 6, displayName : 'Renewal Declined', value: RenewalStatusValue.RENEWAL_DECLINED, group: 'Renewal', inChart: false},
      {filterIndex: 7, displayName : 'Referred to Underwriting', value: RenewalStatusValue.REFERRED_TO_UNDERWRITING, group: 'Renewal', inChart: true},
      {filterIndex: 8, displayName : 'Renewal Period Expired', value: RenewalStatusValue.RENEWAL_PERIOD_EXPIRED, group: 'Renewal', inChart: false},
      {filterIndex: 9, displayName : 'Non-Renewed', value: RenewalStatusValue.NON_RENEWED, group: 'Renewal', inChart: false}
    ];
    this.selectedRenewalStatus = this.filterObj.find((obj: any) => { return obj.group == 'Renewal' && obj.value == 'All' });
    this.renewalStatus = this.selectedRenewalStatus.value;
  }

  ngAfterContentChecked() {
    setTimeout(() => {
      if(!this.viewDestroyed){
        let _renewalPeriodOpenGray = this.renewalPeriodOpenHeight;
        if (this.renewalPeriodOpenGray != _renewalPeriodOpenGray) {
          this.renewalPeriodOpenGray = _renewalPeriodOpenGray;
          
          if (this.cdRef as ViewRef) {
            this.cdRef.detectChanges();
          }
        }
        
        let _renewalInProgressGray = this.renewalInProgressHeight;
        if (this.renewalInProgressGray != _renewalInProgressGray) {
          this.renewalInProgressGray = _renewalInProgressGray;
          if (this.cdRef as ViewRef) {
            this.cdRef.detectChanges();
          }
        }
        
        let _offlineProcessingGray = this.offlineProcessingHeight;
        if (this.offlineProcessingGray != _offlineProcessingGray) {
          this.offlineProcessingGray = _offlineProcessingGray;
          if (this.cdRef as ViewRef) {
            this.cdRef.detectChanges();
          }
        }
        
        let _referredToUWGray = this.referredToUWHeight;
        if (this.referredToUWGray != _referredToUWGray) {
          this.referredToUWGray = _referredToUWGray;
          if (this.cdRef as ViewRef) {
            this.cdRef.detectChanges();
          }
        }
        
        let _renewalBoundGray = this.renewalBoundHeight;
        if (this.renewalBoundGray != _renewalBoundGray) {
          this.renewalBoundGray = _renewalBoundGray;
          if (this.cdRef as ViewRef) {
            this.cdRef.detectChanges();
          }
        }
      }
    },100);
  }

  setHeaderData(){
    this.headerData.pageTitle = "Renewals Overview";
    this.renewalsService.header = this.headerData;
  }
  
  get total$() { return this._total$.asObservable(); }
  
  //#region For Chart
  get renewalPeriodOpenFilter(): any{
    return this.filterObj.find((_filterObj: any) => _filterObj.value == RenewalStatusValue.RENEWAL_PERIOD_OPEN);
  }
  
  get renewalInProgressFilter(): any{
    return this.filterObj.find((_filterObj: any) => _filterObj.value == RenewalStatusValue.RENEWAL_IN_PROGRESS);
  }
  
  get offlineProcessingFilter(): any{
    return this.filterObj.find((_filterObj: any) => _filterObj.value == RenewalStatusValue.OFFLINE_PROCESSING);
  }
  
  get referredToUWFilter(): any{
    return this.filterObj.find((_filterObj: any) => _filterObj.value == RenewalStatusValue.REFERRED_TO_UNDERWRITING);
  }
  
  get renewalBoundFilter(): any{
    return this.filterObj.find((_filterObj: any) => _filterObj.value == RenewalStatusValue.RENEWAL_BOUND);
  }

  get renewalPeriodOpenHeight(): any {
    return this.renewalPeriodOpen?this.renewalPeriodOpen.nativeElement.offsetHeight <= 15:false;
  }
  
  get renewalInProgressHeight(): any {
    return this.renewalInProgress?this.renewalInProgress.nativeElement.offsetHeight <= 15:false;
  }
  
  get offlineProcessingHeight(): any {
    return this.offlineProcessing?this.offlineProcessing.nativeElement.offsetHeight <= 15:false;
  }
  
  get referredToUWHeight(): any {
    return this.referredToUW?this.referredToUW.nativeElement.offsetHeight <= 15:false;
  }
  
  get renewalBoundHeight(): any {
    return this.renewalBound?this.renewalBound.nativeElement.offsetHeight <= 15:false;
  }
  //#endregion
  
  /* ***Filter Code*** */
  onFilter(selectedStatus, accountName, type = null) {
    if(type == this.selectedRenewalStatus.group){
      this.selectedRenewalStatus = this.filterObj.find((obj: any) => { return obj.group == 'Renewal' && obj.value == selectedStatus });
      this.renewalStatus = this.selectedRenewalStatus.value;
    }
    this.criteria.filterBy = [{
      "FilterColumnName": this.selectedRenewalStatus.group,
      "FilterValue": this.selectedRenewalStatus.value
    }];
    this.criteria.pageNo = 1;
    
    //this.loading = true;
    if(this.selectedRenewalStatus.value.toLowerCase() == 'all' || this.selectedRenewalStatus.value.toLowerCase() == ''){
      this.renewals = JSON.parse(JSON.stringify(this.allRenewals)); 
      this.renewals = this.allRenewals.filter(_renewal => _renewal.accountName.toLowerCase().indexOf(accountName.trim().toLowerCase())>-1);
    } else {
      if (this.selectedRenewalStatus.value == 'NonRenewed') {
        //this.renewals = this.allRenewals.filter(_renewal => _renewal.expiringPolicies.filter(_policy => _policy.nonrenewalIndicator));
        this.renewals = this.allRenewals.filter(_renewal => _renewal.accountName.toLowerCase().indexOf(accountName.trim().toLowerCase()) > -1);
        this.renewals = this.renewals.filter((_renewal)=> {
            return _renewal.expiringPolicies.some( (_policy) =>{
                return _policy.nonrenewalIndicator
            });
        });
        /* this.allRenewals.map((element) => {
          return {...element, expiringPolicies: element.expiringPolicies.filter((_policy) => _policy.nonrenewalIndicator)}
        }) */
      }else{
        this.renewals = this.allRenewals.filter(_renewal => _renewal.renewalStatus === this.selectedRenewalStatus.displayName && _renewal.accountName.toLowerCase().indexOf(accountName.trim().toLowerCase()) > -1);
      }
    }
    //this.loading = false;
    this._total$.next(this.renewals.length);
  }
  

  getFilteredData(_filter){
    if(_filter.filterIndex==0){
      delete this.renewalStatusFilter['category'];
    }else{
      this.renewalStatusFilter['category'] = _filter.displayName;
    }

    console.log(this.renewalStatusFilter);
  }
  /* Filter Code */

  /* ***Sorting Code*** */
  compare(v1, v2) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction === '') {
    } else {
      console.log("Call WebAPI to sort " + column + " column in " + direction + " order");
      return this.renewals.sort((a, b) => {
        const res = this.compare(a[column].toLowerCase(), b[column].toLowerCase());
        return direction === 'asc' ? res : -res;
      });
    }
  }
  /* Sorting Code */
  gotoManageRenewal(_renewal) {
    let renewalAccount = { accountName: _renewal.accountName, data: { renewalNumber: _renewal.renewalNumber, accountNumber: _renewal.accountNumber } };
    this.renewalsService.renewalAccountData = renewalAccount;
    this.router.navigateByUrl("renewals/" + _renewal.renewalNumber + "/" + _renewal.accountNumber + "/manage");
  }

  onPageChange(){
    window.scrollTo(0, 0);
  }

  fetchRenewals() {
    this.loading = true;
    let fetchRenewalsSubscription = this.renewalsService.fetchRenewals().subscribe((_renewals:any) => {
      this.loading = false;
      if(_renewals && _renewals.renewals){
        this.allRenewals = _renewals.renewals;
        this.renewals = JSON.parse(JSON.stringify(this.allRenewals));
        this.renewalSummary = _renewals.summary;
        // Calling DrawChart method on time because we need to change the height of elements. Elmenets are not ready without setTimeout.
        setTimeout(() => {       
          this.drawChart();
        }, 200);
      
        this._total$.next(this.allRenewals.length);
      }
    },
    error => {
      this.loading = false;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });
    
    this.renewalsService.runningServices.push(fetchRenewalsSubscription);
  }

  drawChart() {
    (this.renewalPeriodOpen.nativeElement as HTMLElement).style.height = this.getBarValue(this.renewalSummary.pendingAccountsByStatus.openPeriod, this.renewalSummary.totalAccountsPendingRenewal) + "%";
    (this.renewalInProgress.nativeElement as HTMLElement).style.height = this.getBarValue(this.renewalSummary.pendingAccountsByStatus.inProgress, this.renewalSummary.totalAccountsPendingRenewal) + "%";
    (this.offlineProcessing.nativeElement as HTMLElement).style.height = this.getBarValue(this.renewalSummary.pendingAccountsByStatus.offline, this.renewalSummary.totalAccountsPendingRenewal) + "%";
    (this.referredToUW.nativeElement as HTMLElement).style.height = this.getBarValue(this.renewalSummary.pendingAccountsByStatus.referUW, this.renewalSummary.totalAccountsPendingRenewal) + "%";
    (this.renewalBound.nativeElement as HTMLElement).style.height = this.getBarValue(this.renewalSummary.pendingAccountsByStatus.bound, this.renewalSummary.totalAccountsPendingRenewal) + "%";
  }
  getBarValue(_actualValue, _actualTotal) {
    return ((((this.chart.nativeElement).offsetHeight * _actualValue)/_actualTotal) * 100) / (this.chart.nativeElement).offsetHeight;
  }
  
  getRenewalStatusClass(status) {
    if(status){
      if (status.toLowerCase() === RenewalStatus.RENEWAL_PERIOD_OPEN) {
        return "renewal-period-open";
      } else if (status.toLowerCase() === RenewalStatus.RENEWAL_IN_PROGRESS) {
        return "renewal-in-progress";
      } else if (status.toLowerCase() === RenewalStatus.OFFLINE_PROCESSING) {
        return "offline-processing";
      } else if (status.toLowerCase() === RenewalStatus.RENEWAL_BOUND) {
        return "renewal-bound";
      } else if (status.toLowerCase() === RenewalStatus.RENEWAL_ISSUED) {
        return "renewal-issued";
      } else if (status.toLowerCase() === RenewalStatus.RENEWAL_DECLINED) {
        return "renewal-declined";
      } else if (status.toLowerCase() === RenewalStatus.RENEWAL_PERIOD_EXPIRED) {
        return "renewal-period-expired";
      } else if (status.toLowerCase() === RenewalStatus.NON_RENEWED) {
        return "non-renewed";
      } else if (status.toLowerCase() === RenewalStatus.REFERRED_TO_UNDERWRITING) {
        return "referred-to-underwriting";
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
  
  ngOnDestroy() {
    this.cdRef.detach();
    this.viewDestroyed = true;
    this.renewalsService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }

}
